import Head from "next/head"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { i18n } from "next-i18next"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import { footerUrl, headerUrl, REMEDY_MODEL_JSON } from "@/constants"
import {
  fetchPageModel,
  fetchPageShell,
} from "@/services/server/aemPageData.server"
import { filterBackEndJson, getDataLayerObj } from "@/utils/helper"
import { handleServerSideRouteError } from "@/utils/serverSideError"
import Remedy from "@/components/Remedy/Remedy"
import { useEffect } from "react"
import usePageAuth from "@/hooks/usePageAuth"

/**
 *
 * @return {JSX.Element}
 */
const RemedyPage = ({
  tmpData = {},
  header,
  footer,
  analyticsData = {},
  remedyShopNowUtils = {},
}) => {
  const { ctaTitle = "", ctaUrl = "" } = remedyShopNowUtils || {}
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])

  usePageAuth()
  return (
    <>
      <Head>
        <title>
          Kohler x Remedy Place Ice Bath - A New Dimension of Self Care
        </title>
        <meta
          name="description"
          content="Discover the Kohler x Remedy Place Ice Bath, experience wellness at 39°F"
        />
      </Head>
      {header ? (
        <GlobalPageHeader
          themeType={
            tmpData?.appliedCssClassNames ??
            "nav-light-theme nav-transparent-light-theme"
          }
          header={header}
          title={tmpData?.title}
          data={tmpData}
        />
      ) : null}
      {/* {header ? <GlobalPageHeader header={header} /> : null} */}
      <Remedy ctaTitle={ctaTitle} ctaUrl={ctaUrl} />
      {footer ? <GlobalPageFooter footer={footer} /> : null}
    </>
  )
}

/**
 *
 * @return {Object}
 */
export async function getServerSideProps({ req, locale }) {
  try {
    await i18n?.reloadResources()
    const urlPath = ""

    const data = (await fetchPageModel(`/${locale}${REMEDY_MODEL_JSON}`)) || {}

    const headerModelUrl = `${headerUrl}.model.json`
    const footerModelUrl = `${footerUrl}.model.json`
    const { header: headerData, footer: footerData } = await fetchPageShell({
      headerModelUrl,
      footerModelUrl,
      pageName: "Remedy",
      context: { locale },
    })

    const { data: analyticsData = {} } = data
    let tmpData = {}
    if (data.pageComponentProperties) {
      tmpData = data.pageComponentProperties
    } else {
      tmpData = data
    }
    tmpData = filterBackEndJson(tmpData)

    const remedyShopNowUtils = {}

    if (tmpData[":itemsOrder"].length) {
      const teaser =
        tmpData?.[":items"]?.root?.[":items"]?.container?.[":items"]?.teaser
      if (teaser) {
        const { actions = [] } = teaser || {}
        if (actions.length) {
          const { title = "", url = "" } = actions[0] || {}
          remedyShopNowUtils.ctaTitle = title
          remedyShopNowUtils.ctaUrl = url
        }
      }
    }

    let header
    if (headerData) header = filterBackEndJson(headerData)
    let footer
    if (footerData) footer = filterBackEndJson(footerData)
    // Pass data to the page via props
    return {
      props: {
        tmpData,
        header,
        footer,
        analyticsData,
        urlPath,
        remedyShopNowUtils,
        ...(await serverSideTranslations(locale, ["common"])),
      },
    }
  } catch (error) {
    return handleServerSideRouteError("remedy page data fetch failed", error)
  }
}

export default RemedyPage
